import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const itemsList: ThemeUICSSObject = {
  item: {
    display: 'block',
  },
};
